import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import ReactApexChart from "react-apexcharts";
import Header from "../Dashboard/Header";
import FooterStrict from "../../Pages/Dashboard/FooterStrict";
import LineAnalysisChart from "../../Components/LineAnalysisChart";
import BarAnalysisChart from "../../Components/BarAnalysisChart";

import {
  getWeeklyRevenue,
  getWeeklyUnitSold,
  getMonthlyUnitSold,
  getMonthlyRevenue,
  getFilter,
  getStoresByMonth,
  getRetailersByMonth,
  getShopperCount
} from "../../API/Chart";
import BrandImg from "../../Assets/images/shoppers.svg";
import { dropDownOnChangeHandleAllOrOthers } from "../../helper";
import { getCustomCategories } from "../../API/Category";


function getFilterOptions(array, labelKey, valueKey) {
  if (!labelKey && !valueKey) {
    return array.map((item) => ({ value: item, label: item }));
  }
  return array.map((item) => ({
    value: item[valueKey],
    label: item[labelKey]
  }));
}

const Tabs = {
  unitsSold: "unitsSold",
  revenue: "revenue",
  barChart: "barChart",
  weekly: "weekly",
  monthly: "monthly"
};

const defaultFilters = {
  Brands: "",
  BusinessType: "",
  BusinessTypefilterBy: "",
  StartDate: "",
  EndDate: "",
  Loyalty: "",
  Stores: ""
};

const CategoryAnalyzer = () => {
  const { cacid } = useParams();
  const isInitialLoad = useRef(true);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(Tabs.weekly);
  const [weeklyUnitsSold, setWeeklyUnitsSold] = useState([]);
  const [weeklyRevenue, setWeeklyRevenue] = useState([]);
  const [monthlyUnitsSold, setMonthlyUnitsSold] = useState([]);
  const [monthlyRevenue, setMonthlyRevenue] = useState([]);
  const [monthlyStores, setMonthlyStores] = useState([]);
  const [monthlyRetailers, setMonthlyRetailers] = useState([]);
  const [ShopperCount, setShopperCount] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [syncStatus, setSyncStatus] = useState(null);
  const [syncError, setSyncError] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [showError, setShowError] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    brands: [],
    retailers: [],
    dateRanges: [],
    loyaltyOptions: [],
    storeOptions: [],
    retailerFilters: [],
    wholesalers: []
  });

  const brands = (
    ShopperCount?.brands?.length ? ShopperCount.brands : filterOptions.brands
  )?.filter((b) => b.label !== "All Brands");

  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedLoyalty, setSelectedLoyalty] = useState({});
  const [selectedStore, setSelectedStore] = useState({});

  const [filterBy, setFilterBy] = useState({});
  const [filterByValue, setFilterByValue] = useState([]);

  

  const [filters, setFilters] = useState(defaultFilters);

  const [filtersClone, setFiltersClone] = useState(null);

  async function getData(params = {}) {
    try {

      if (JSON.stringify(defaultFilters) != JSON.stringify(filtersClone)) {
        setFiltersClone(filters);
      }
      const _startDate = params.startDate || startDate;
      const _endDate = params.endDate || endDate;
      const _selectedBrands = params.selectedBrands || selectedBrands;
      const _filterBy = params.filterBy || filterBy;
      const _filterByValue = params.filterByValue || filterByValue;
      const _selectedLoyalty = params.selectedLoyalty || selectedLoyalty;
      const _selectedStore = params.selectedStore || selectedStore;
      let _activeTab = activeTab;
      if (params.activeTab) {
        _activeTab = params.activeTab;
        setActiveTab(_activeTab);
      }

      let dateErrorMsg = "";
      if (!_startDate && !_endDate) {
        dateErrorMsg = "Please select date range";
      } else if (!_startDate) {
        dateErrorMsg = "Please select start date";
      } else if (!_endDate) {
        dateErrorMsg = "Please select end date";
      }
      if (dateErrorMsg) {
        setShowError(true);
        setDateError(dateErrorMsg);
        return;
      }
      setShowError(false);
      setDateError("");

      setLoading(true);

      const urlParams = new URLSearchParams();

      if (_selectedBrands?.length) {
        urlParams.append(
          "brands",
          _selectedBrands.map((i) => i.value).join(",")
        );
      }

      if (_filterBy) {
        urlParams.append("filter_by", _filterBy.value);
      }

      if (_filterByValue?.length) {
        urlParams.append(
          "filter_by_value",
          _filterByValue.map((i) => i.value).join(",")
        );
      }

      if (_selectedLoyalty) {
        urlParams.append("loyalty", _selectedLoyalty.value);
      }

      if (_selectedStore) {
        urlParams.append("stores", _selectedStore.value);
      }

      if (cacid) {
        urlParams.append("cacid", cacid);
      }

      if (_startDate) {
        urlParams.append("start_date", _startDate);
      }

      if (_endDate) {
        urlParams.append("end_date", _endDate);
      }

      function updateShopperData(_shopperData) {
        setShopperCount(_shopperData || []);
        if (_shopperData?.brands) {
          setBrandsData(
            _shopperData.brands.map((item) => ({
              count: Number(item.value).toLocaleString(),
              label: item.label
            }))
          );
        }
      }

      if (_activeTab === Tabs.weekly) {
        const [weeklyUnitsData, weeklyRevenueData, _shopperData] =
          await Promise.all([
            getWeeklyUnitSold(urlParams),
            getWeeklyRevenue(urlParams),
            getShopperCount(urlParams)
          ]);
        setWeeklyUnitsSold(weeklyUnitsData || []);
        setWeeklyRevenue(weeklyRevenueData || []);
        updateShopperData(_shopperData);
      } else {
        const [
          monthlyUnitsData,
          monthlyRevenueData,
          monthlystoresData,
          monthlyRetailersData,
          _shopperData
        ] = await Promise.all([
          getMonthlyUnitSold(urlParams),
          getMonthlyRevenue(urlParams),
          getStoresByMonth(urlParams),
          getRetailersByMonth(urlParams),
          getShopperCount(urlParams)
        ]);
        setMonthlyUnitsSold(monthlyUnitsData || []);
        setMonthlyRevenue(monthlyRevenueData || []);
        setMonthlyStores(monthlystoresData || []);
        setMonthlyRetailers(monthlyRetailersData || []);
        updateShopperData(_shopperData);
      }

      setLoading(false);
    } catch (error) {
      console.error(" Error", error);
    } finally {
      setLoading(false);
    }
  }

  async function getFilterData() {
    const [_customCategories, _filterData] = await Promise.all([
      getCustomCategories(),
      getFilter(cacid)
    ]);

    const foundCategory = _customCategories?.find((c) => c.category_id === +cacid);
    setCategoryName(foundCategory?.category_name ?? "");
    setSyncStatus(foundCategory?.bq_sync_status ?? null);
    setSyncError(foundCategory?.bq_sync_error ?? null);

    const convertedOptions = {
      brands: getFilterOptions(_filterData?.brands, "", "") || [],
      retailerFilters:
        getFilterOptions(_filterData?.retailerFilters, "", "") || [],
      loyaltyOptions:
        getFilterOptions(_filterData?.loyaltyOptions, "", "") || [],
      storeOptions: getFilterOptions(_filterData?.storeOptions, "", "") || [],
      wholesalers: _filterData?.wholesalers,
      retailers: _filterData?.retailerGroups
    };
    setFilterOptions(convertedOptions);

    const retailerFilter = convertedOptions.retailerFilters[0];
    setFilterBy(retailerFilter);
    setFilters((prev) => ({ ...prev, BusinessType: retailerFilter }));

    const filterValue =
      retailerFilter?.value === "Wholesalers"
        ? _filterData?.wholesalers?.[0]
        : _filterData?.retailerGroups[0];
    setFilterByValue(filterValue);
    setFilters((prev) => ({
      ...prev,
      BusinessTypefilterBy: filterValue
    }));

    const selectedBrand = [convertedOptions.brands[0]];
    setSelectedBrands(selectedBrand);
    setFilters((prev) => ({
      ...prev,
      Brands: selectedBrand
    }));

    const loyalty = convertedOptions.loyaltyOptions[0];
    setSelectedLoyalty(loyalty);
    setFilters((prev) => ({ ...prev, Loyalty: loyalty }));

    const store = convertedOptions.storeOptions[0];
    setSelectedStore(store);
    setFilters((prev) => ({
      ...prev,
      Stores: store
    }));

    const today = new Date();
    const ninetyDaysAgo = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);

    const startDate = formatLocalDate(ninetyDaysAgo);
    const endDate = formatLocalDate(today);

    setEndDate(endDate);
    setStartDate(startDate);

    setFilters((prev) => ({
      ...prev,
      StartDate: startDate
    }));

    setFilters((prev) => {
      const updated = { ...prev, EndDate: endDate };
      if (updated.Brands !== "") {
        setFiltersClone(updated);
      }

      return updated;
    });

    isInitialLoad.current = false;

    


    return {
      selectedBrand,
      retailerFilter,
      filterValue,
      loyalty,
      store,
      startDate,
      endDate,
      syncStatus: foundCategory?.bq_sync_status ?? null
    };
  }

  const isFilterActive = Object.values(filters).some((v) => v !== "");
  const applyFilter = () => {
    alert(`Filters applied:\n${JSON.stringify(filters, null, 2)}`);
  };

  const CARD_COLORS = ["#3d8ecc", "#2ecc71", "#f39c12", "#9b59b6", "#e74c3c", "#1abc9c", "#e67e22"];


  const isDeepEqual = (a, b) => {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
  
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      const sortedA = [...a].sort((x, y) =>
        JSON.stringify(x).localeCompare(JSON.stringify(y))
      );
      const sortedB = [...b].sort((x, y) =>
        JSON.stringify(x).localeCompare(JSON.stringify(y))
      );
      return sortedA.every((item, i) => isDeepEqual(item, sortedB[i]));
    }
  
    if (typeof a === "object" && a !== null && b !== null) {
      const keysA = Object.keys(a).sort();
      const keysB = Object.keys(b).sort();
      if (keysA.length !== keysB.length) return false;
      return keysA.every(
        (key, i) => keysB[i] === key && isDeepEqual(a[key], b[key])
      );
    }
  
    return a === b;
  };

  useEffect(() => {
    const initializeData = async () => {
      const filterData = await getFilterData();

      if (filterData.syncStatus !== "SYNCED") return;

      getData({
        startDate: filterData.startDate,
        endDate: filterData.endDate,
        selectedBrands: filterData.selectedBrand,
        filterBy: filterData.retailerFilter,
        filterByValue: filterData.filterValue,
        selectedLoyalty: filterData.loyalty,
        selectedStore: filterData.store
      });
    };

    initializeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <>
      <Header location={`companyProfile`} />
      <section className="ContentBlock pt-40 pb-24 Main_Block">
        <div className="category-segment-section">
          <div className="container-fluid">
            <div className="Common_Block mb-30">
              <div className="Common_Block_Header d-flex align-items-center justify-content-between">
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <h5 style={{ margin: 0 }}>Competitive Analysis View: {categoryName}</h5>
                  {syncStatus && (() => {
                    const cfg = {
                      PENDING: { label: "Processing", bg: "#9ca3af" },
                      SYNCED:  { label: "Live",       bg: "#16a34a" },
                      FAILED:  { label: "Failed",     bg: "#dc2626" },
                    }[syncStatus] || { label: syncStatus, bg: "#9ca3af" };
                    return (
                      <span style={{
                        display: "inline-block", padding: "3px 10px", borderRadius: "12px",
                        fontSize: "11px", fontWeight: 600, background: cfg.bg, color: "#fff",
                        letterSpacing: "0.3px"
                      }}>
                        {cfg.label}
                      </span>
                    );
                  })()}
                </div>
                <Link
                  to="/custom-analysis-categories"
                  style={{
                    background: "#fff",
                    color: "#3d8ecc",
                    border: "1px solid #3d8ecc",
                    fontWeight: 600,
                    padding: "6px 14px",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontSize: "14px"
                  }}
                >
                  ← Back to Category Competitive Analysis
                </Link>
              </div>

              <div className="Common_Block_Body pt-17 pb-17 pr-14 pl-14">
                {syncStatus !== "SYNCED" && (
                  <div style={{
                    textAlign: "center", padding: "60px 20px",
                    color: syncStatus === "FAILED" ? "#dc2626" : "#6b7280"
                  }}>
                    {syncStatus === "FAILED" ? (
                      <>
                        <div style={{ fontSize: "36px", marginBottom: "12px" }}>⚠</div>
                        <p style={{ fontWeight: 600, fontSize: "15px", margin: "0 0 6px" }}>
                          This category failed to sync
                        </p>
                        {syncError && (
                          <p style={{ fontSize: "13px", color: "#9ca3af", margin: 0 }}>{syncError}</p>
                        )}
                      </>
                    ) : syncStatus === "PENDING" ? (
                      <>
                        <div style={{ fontSize: "36px", marginBottom: "12px" }}>⏳</div>
                        <p style={{ fontWeight: 600, fontSize: "15px", margin: "0 0 6px" }}>
                          This category is being processed
                        </p>
                        <p style={{ fontSize: "13px", color: "#9ca3af", margin: 0 }}>
                          Analysis data will be available once syncing is complete.
                        </p>
                      </>
                    ) : (
                      <>
                        <div style={{ fontSize: "36px", marginBottom: "12px" }}>—</div>
                        <p style={{ fontWeight: 600, fontSize: "15px", margin: 0 }}>
                          Sync status unavailable
                        </p>
                      </>
                    )}
                  </div>
                )}
                {syncStatus === "SYNCED" && (
                <>
                {/* Filter Bar */}
                <div className="sales-filters" style={{ marginBottom: "20px" }}>
                  {/* Brands */}
                  <div className="filter-group">
                    <label>Brands</label>
                    <Select
                      isMulti
                      placeholder="Select Brand"
                      options={filterOptions.brands}
                      onChange={(selected) => {
                        dropDownOnChangeHandleAllOrOthers(selected, setSelectedBrands);
                        setFilters((prev) => ({
                          ...prev,
                          Brands: selected.length > 1 ? selected.filter((i) => i.value !== "All Brands") : selected
                        }));
                      }}
                      value={selectedBrands}
                    />
                  </div>

                  {/* Filter by */}
                  <div className="filter-group">
                    <label>Filter by</label>
                    <Select
                      options={filterOptions.retailerFilters}
                      onChange={(e) => {
                        setFilterBy(e);
                        if (e?.value === "Wholesalers") {
                          setFilterByValue(filterOptions.wholesalers?.[0]);
                        } else {
                          setFilterByValue(filterOptions.retailers?.[0]);
                        }
                        setFilters((prev) => ({ ...prev, BusinessType: e }));
                      }}
                      value={filterBy}
                    />
                  </div>

                  {/* Dynamic filter value */}
                  {filterBy && (
                    <div className="filter-group">
                      <label>Select {filterBy.value || filterBy.label}</label>
                      <Select
                        isMulti
                        options={filterBy.value === "Wholesalers" ? filterOptions.wholesalers : filterOptions.retailers}
                        onChange={(selected) => {
                          dropDownOnChangeHandleAllOrOthers(selected, setFilterByValue);
                          setFilters((prev) => ({
                            ...prev,
                            BusinessTypefilterBy: selected.at(-1)?.label?.toLowerCase()?.startsWith("all")
                              ? [selected.at(-1)]
                              : selected.filter((i) => !i.label?.toLowerCase()?.startsWith("all"))
                          }));
                        }}
                        value={filterByValue}
                      />
                    </div>
                  )}

                  {/* Date range */}
                  <div className="filter-group">
                    <label>Date Range</label>
                    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                      <input
                        type="date"
                        value={startDate}
                        max={endDate || undefined}
                        onChange={(e) => {
                          const val = e.target.value;
                          setStartDate(val);
                          setFilters((prev) => ({ ...prev, StartDate: val }));
                        }}
                        style={{ padding: "6px 10px", border: "1px solid #ced4da", borderRadius: "4px", fontSize: "13px" }}
                      />
                      <span style={{ color: "#666", fontSize: "12px" }}>to</span>
                      <input
                        type="date"
                        value={endDate}
                        min={startDate || undefined}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          const val = e.target.value;
                          setEndDate(val);
                          setFilters((prev) => ({ ...prev, EndDate: val }));
                        }}
                        style={{ padding: "6px 10px", border: "1px solid #ced4da", borderRadius: "4px", fontSize: "13px" }}
                      />
                    </div>
                    {showError && <p style={{ color: "#dc3545", fontSize: "11px", margin: "4px 0 0" }}>{dateError}</p>}
                  </div>

                  {/* Loyalty */}
                  <div className="filter-group">
                    <label>Loyalty</label>
                    <Select
                      placeholder="All"
                      options={filterOptions.loyaltyOptions}
                      onChange={(selected) => {
                        setSelectedLoyalty(selected);
                        setFilters((prev) => ({
                          ...prev,
                          Loyalty: { label: selected?.value, value: selected?.value } || ""
                        }));
                      }}
                      value={selectedLoyalty}
                    />
                  </div>

                  {/* Onboard Stores */}
                  <div className="filter-group">
                    <label>Onboard Stores</label>
                    <Select
                      placeholder="All Stores"
                      value={selectedStore}
                      options={filterOptions.storeOptions}
                      onChange={(selected) => {
                        setSelectedStore(selected);
                        setFilters((prev) => ({
                          ...prev,
                          Stores: { label: selected?.value, value: selected?.value } || ""
                        }));
                      }}
                    />
                  </div>

                  {/* Apply */}
                  <div className="filter-group search-btn">
                    <br />
                    <button
                      onClick={() => getData()}
                      disabled={isDeepEqual(filters, filtersClone)}
                      style={{
                        padding: "8px 18px",
                        background: isDeepEqual(filters, filtersClone) ? "#ccc" : "#3d8ecc",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: isDeepEqual(filters, filtersClone) ? "not-allowed" : "pointer",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "background 0.2s"
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>

                {/* Brand shopper share — donut chart */}
                {brands.length > 0 && (
                  <div style={{
                    background: "#fff",
                    borderRadius: "8px",
                    border: "1px solid #e8e8e8",
                    padding: "16px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
                  }}>
                    <h6 style={{ color: "#3d8ecc", fontWeight: 600, fontSize: "14px", marginBottom: "2px" }}>
                      Shopper Share by Brand
                    </h6>
                    <p style={{ color: "#999", fontSize: "12px", margin: "0 0 4px" }}>
                      Relative shopper distribution across brands
                    </p>
                    <ReactApexChart
                      type="donut"
                      height={320}
                      series={brands.map(b => Number(b.value ?? b.count) || 0)}
                      options={{
                        labels: brands.map(b => b.label),
                        colors: CARD_COLORS,
                        chart: { fontFamily: "inherit" },
                        dataLabels: { enabled: true, formatter: (val, opts) => `${val.toFixed(1)}%` },
                        plotOptions: {
                          pie: {
                            donut: {
                              size: "60%",
                              labels: {
                                show: true,
                                total: {
                                  show: true,
                                  label: "Total Shoppers",
                                  fontSize: "13px",
                                  color: "#666",
                                  formatter: (w) =>
                                    w.globals.seriesTotals.reduce((a, b) => a + b, 0).toLocaleString()
                                }
                              }
                            }
                          }
                        },
                        legend: { position: "right", fontSize: "12px" },
                        tooltip: { y: { formatter: val => val.toLocaleString() } }
                      }}
                    />
                  </div>
                )}

                {/* Weekly / Monthly toggle */}
                <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
                  <div style={{
                    display: "inline-flex",
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    overflow: "hidden"
                  }}>
                    {[
                      { key: Tabs.weekly, label: "Weekly Summary" },
                      { key: Tabs.monthly, label: "Monthly Summary" }
                    ].map(({ key, label }, idx) => {
                      const isActive = activeTab === key;
                      return (
                        <button
                          key={key}
                          onClick={() => getData({ activeTab: key })}
                          style={{
                            padding: "8px 20px",
                            border: "none",
                            borderRight: idx === 0 ? "1px solid #dee2e6" : "none",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: 500,
                            background: isActive ? "#3d8ecc" : "#fff",
                            color: isActive ? "#fff" : "#555",
                            transition: "all 0.2s"
                          }}
                        >
                          {label}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Charts */}
                <div className="produce-department shoppers-chart">
                  <div className="chart-wrapper">
                    {loading ? (
                      <div style={{
                        height: "300px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px"
                      }}>
                        <div style={{
                          width: 36, height: 36, borderRadius: "50%",
                          border: "3px solid #dee2e6",
                          borderTopColor: "#3d8ecc",
                          animation: "spin 0.8s linear infinite"
                        }} />
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                        <p style={{ color: "#999", fontSize: "13px", margin: 0 }}>Loading chart data…</p>
                      </div>
                    ) : (
                      <>
                        {activeTab === Tabs.weekly && (
                          <>
                            <LineAnalysisChart title="Units Sold by Week" data={weeklyUnitsSold} yAxisLabel="Units" />
                            <LineAnalysisChart title="Revenue by Week" data={weeklyRevenue} yAxisLabel="Revenue" />
                          </>
                        )}
                        {activeTab === Tabs.monthly && (
                          <>
                            <BarAnalysisChart title="Units Sold" data={monthlyUnitsSold} yAxisLabel="Units" variant="heatmap" />
                            <BarAnalysisChart title="Revenue" data={monthlyRevenue} yAxisLabel="Revenue" variant="heatmap" />
                            <BarAnalysisChart title="Stores Carrying Brands" data={monthlyStores} yAxisLabel="Stores" variant="heatmap" />
                            <BarAnalysisChart title="Retailers Carrying Brands" data={monthlyRetailers} yAxisLabel="Retailers" variant="heatmap" />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterStrict />
    </>
  );
};

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default CategoryAnalyzer;
